import { useCallback, useEffect, useState } from "react";
import { Tabs } from "./Tabs";
import { SEO } from "../SEO/SEO";
import { PromocodeList } from "./PromocodeList";
import { PromocodeForm } from "./PromocodeForm";
import { Promocode } from "../../interfaces/promocode";
import { getAllPromocodes } from "../../services/axios";
import { ReactComponent as Plus } from "../../assets/images/promoPlus.svg";

export const AdminMarketing = () => {
  const [promocodes, setPromocodes] = useState<Promocode[] | []>([]);
  const [promocode, setPromocode] = useState<Promocode | null>(null);
  const [creating, setCreating] = useState(false);

  const fetchPromocodes = useCallback(async () => {
    const data = await getAllPromocodes();
    setPromocodes(data || []);
  }, []);

  useEffect(() => {
    fetchPromocodes();
  }, [fetchPromocodes]);

  return promocode || creating ? (
    <>
      <SEO title="Редагування промокоду" noIndex />
      <PromocodeForm
        promocode={promocode}
        setPromocode={setPromocode}
        setCreating={setCreating}
        refetch={fetchPromocodes}
      />
    </>
  ) : (
    <>
      <SEO title="Адмінка" noIndex />
      <Tabs />
      <div className="admin__promo--createWrapper">
        <button
          type="button"
          className="admin__promo--create"
          onClick={() => {
            setCreating(true);
          }}
        >
          Create new discount code
          <Plus />
        </button>
      </div>
      <PromocodeList promocodes={promocodes} setPromocode={setPromocode} />
    </>
  );
};
